module.exports = __webpack_public_path__ + "static/img/gzy.b9746525.jpg";